/**
 * Created by admin on 2018/5/22.
 */
import React, { PureComponent } from 'react';
import { downloadCanvas } from 'download-canvas';
import { Modal } from 'antd';
import QRCode from 'qrcode.react';
import './RoomQrModal.less';
import { Btn } from '../Widgets';
import { FormattedMessage } from 'react-intl';

class RoomQrModal extends PureComponent {
  static defaultProps = {
    visible: false,
    currentRoomInfo: {}
  };

  render() {
    const { intl, visible, currentRoomInfo = {} } = this.props;
    const { id: roomId = '', name = '' } = currentRoomInfo;
    return (
      <Modal
        destroyOnClose={true}
        visible={visible}
        onCancel={this.close}
        title={intl.formatMessage({ id: 'roomqr_manage' })}
        wrapClassName="room-qr-wrapper modal-close-header"
        width={600}
        footer={
          <div className="edit-footer">
            <Btn onClick={this.close}>
              {intl.formatMessage({ id: 'roomqr_manage_close' })}
            </Btn>
            <Btn primary onClick={this.download}>
              {intl.formatMessage({ id: 'roomqr_manage_download' })}
            </Btn>
          </div>
        }
        closable
      >
        <div className="room-qr">
          <div className="qr-name">{name}</div>
          <div className="room-qr-container" id="room-qr-container">
            <QRCode
              value={`${window.location.origin}/meetingapp/support/${roomId}`}
              size={300}
              level="Q"
            />
          </div>
        </div>
      </Modal>
    );
  }

  close = () => {
    const { onClose } = this.props;
    onClose && onClose();
  };
  download = () => {
    if (!document.getElementById('room-qr')) {
      if (
        document.getElementById('room-qr-container') &&
        document
          .getElementById('room-qr-container')
          .getElementsByTagName('canvas') &&
        document
          .getElementById('room-qr-container')
          .getElementsByTagName('canvas').length > 0
      ) {
        document
          .getElementById('room-qr-container')
          .getElementsByTagName('canvas')[0].id = 'room-qr';
      }
    }
    if (!document.getElementById('room-qr')) {
      window.console.error('初始化二维码失败！');
      return;
    }
    const { currentRoomInfo = '' } = this.props;
    const { name = '' } = currentRoomInfo;
    downloadCanvas('room-qr', {
      name: name, // default image
      type: 'png' // default png, accepted values jpg or png
    });
  };
}

export default RoomQrModal;



// WEBPACK FOOTER //
// ./src/components/account/RoomQrModal.js